import React from "react";
import { cx, useTranslations } from "@jugl-web/utils";
import { PlainButton } from "@jugl-web/ui-components/cross-platform/PlainButton";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import robotAnimation from "./assets/robot-animation.json";

export const AIAssistantLimitAlert: React.FC<{
  orientation: "row" | "column";
  onClose?: () => void;
}> = ({ orientation, onClose }) => {
  const { t } = useTranslations();

  return (
    <div
      className={cx(
        "relative flex flex-col items-center justify-center gap-4 px-6 pb-10 text-center",
        orientation === "row" &&
          "ml-6 flex-row-reverse justify-between gap-0 px-0 pb-0 text-left"
      )}
    >
      {onClose && (
        <PlainButton
          className="bg-dark/5 hover:bg-dark/10 absolute top-4 right-4 flex h-8 w-8 items-center justify-center rounded-full transition-colors"
          onClick={onClose}
        >
          <CloseIcon />
        </PlainButton>
      )}
      <div className="pointer-events-none w-max">
        <Lottie
          isClickToPauseDisabled
          options={{ animationData: robotAnimation }}
          width={140}
        />
      </div>
      <div className="flex flex-col gap-2.5">
        <span className="text-dark font-secondary font-medium leading-4">
          {t({
            id: "ai-assistant-limit-alert-component.out-of-free-ai-actions",
            defaultMessage: "Out of free AI Actions",
          })}
        </span>
        <span className="text-dark-700 font-secondary max-w-[400px] text-sm leading-[21px]">
          {t({
            id: "ai-assistant-limit-alert-component.out-of-free-ai-actions-description",
            defaultMessage:
              "Each day you are given 50 free actions for AI Features ⭐ Please wait for the next day and try again 🥰",
          })}
        </span>
      </div>
    </div>
  );
};
